<template>
    <fieldset :class="[
        'cz2__panel',
        'cz2__panel--secondary',
        'cz2__monogram',
        'cz2__monogram--' + mode
    ]" :disabled="monogramLockDisabled">
        <focus-lock :disabled="focusLockDisabled">
            <div class="cz2__panel__header cz2__panel__header--with-back-button hide--below-sm">
                <div class="cz2__panel-header__back-button">
                    <button class="cz2__panel__back-button" :aria-label="$t('MENU_BACK')" @click.prevent="cancel"></button>
                </div>

                <details-header></details-header>
            </div>

            <!-- List View -->
            <div v-if="mode === 'list'"
                :class="[
                    'cz2__panel__body',
                    {
                        'cz2__panel__body--hack': panelBodyHack
                    }
                ]">
                <panel-header :title="$t('MONOGRAM_TEXTS')" />

                <!-- <div class="cz2__panel-body__back-button hide--below-sm">
                    <button class="cz2__panel__back-button" @click.prevent="cancel">
                        {{$t('MENU_BACK')}}
                    </button>
                </div> -->

                <!-- <div class="cz2__mb-15 hide--above-sm">
                    <div class="cz2__type__small-header cz2__text--center">
                        {{$t('TEXT_TEXTS')}}
                    </div>
                </div> -->

                <div class="cz2__text-list hide--above-sm">
                    <button class="cz2__image-button cz2__image-button--add cz2__image-button--with-text"
                        :aria-label="$t('MONOGRAM_ADD')"
                        @click.prevent="listAddMonogram">
                        <span>{{$t('MONOGRAM_ADD')}}</span>
                    </button>

                    <button v-for="text in filledMonogramPlacements" :key="text.placement.code"
                        class="cz2__image-button cz2__image-button--with-text cz2__image-button--monogram"
                        @click.prevent="listEditMonogram(text)"
                    >
                        <span>{{text.component.custom['personalization-text']}}</span>
                    </button>
                </div>

                <div class="cz2__text-list hide--below-sm">
                    <div class="cz2__text-list-action">
                        <div class="cz2__text-list-action__add-icon" @click.prevent="listAddMonogram">
                        </div>
                        <div class="cz2__text-list-action__text cz2__type__normal" @click.prevent="listAddMonogram">
                            {{$t('MONOGRAM_ADD')}}
                        </div>
                        <div class="cz2__text-list-action__actions">
                            <button class="cz2__image-button cz2__image-button--add"
                                :aria-label="$t('MONOGRAM_ADD')"
                                @click.prevent="listAddMonogram"></button>
                        </div>
                    </div>

                    <div v-for="text in filledMonogramPlacements" :key="text.placement.code" class="cz2__text-list-action">
                        <div class="cz2__text-list-action__monogram-icon" @click.prevent="listEditMonogram(text)">
                        </div>
                        <div class="cz2__text-list-action__text cz2__type__normal">
                            {{text.component.custom['personalization-text']}}
                        </div>
                        <div class="cz2__text-list-action__actions">
                            <button class="cz2__image-button cz2__image-button--remove"
                                :aria-label="$t('MONOGRAM_EDIT_REMOVE')"
                                @click.prevent="listRemoveMonogram(text)"></button>

                            <button class="cz2__image-button cz2__image-button--edit cz2__ml-10"
                                :aria-label="$t('MONOGRAM_EDIT_EDIT')"
                                @click.prevent="listEditMonogram(text)"></button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Edit View -->
            <div v-if="mode === 'edit'"
                :class="[
                    'cz2__panel__body',
                    {
                        'cz2__panel__body--hack': panelBodyHack
                    }
                ]">
                <panel-header :title="$t('MONOGRAM_EDIT')" />

                <!-- <div class="cz2__panel-body__back-button hide--below-sm">
                    <button class="cz2__panel__back-button" @click.prevent="cancelEdit">
                        {{$t('MONOGRAM_EDIT')}}
                    </button>
                </div> -->

                <!-- <div class="cz2__mb-15 hide--above-sm">
                    <div class="cz2__type__small-header cz2__text--center">
                        {{$t('MONOGRAM_EDIT')}}
                    </div>
                </div> -->

                <div :class="[
                    'cz2__text-editor',
                    {
                        'cz2__text-editor--top-level': editMode == null,
                    }
                ]">
                    <div v-if="editMode == null || editMode === 'changeStyle'"
                        :class="[
                            'cz2__text-editor__field',
                            {
                                'cz2__text-editor__field--expanded': editMode === 'changeStyle',
                            }
                        ]"
                    >
                        <div class="cz2__text-editor__field-name cz2__type__small">
                            <button class="cz2__image-button cz2__image-button--with-text cz2__image-button--font"
                                @click.prevent="changeStyle"
                            >
                                <span>{{$t('MONOGRAM_EDIT_STYLE')}}</span>
                            </button>

                            <span>{{$t('MONOGRAM_EDIT_STYLE')}}</span>
                        </div>
                        <div class="cz2__text-editor__field-value">
                            <div class="cz2__monogram__options">
                                <button v-for="option in availableStyles" :key="option.code"
                                    :class="[
                                        'cz2__monogram-option',
                                        {
                                            'cz2__monogram-option--selected': selectedStyleDescription && selectedStyleDescription.code === option.code,
                                        }
                                    ]"
                                    @click.prevent="pickStyle(option)"
                                    :aria-label="option.name"
                                >
                                    <span class="cz2__monogram-option__image" :style="getMonogramStyle(option)">
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="editMode == null || editMode === 'text'" :class="[
                        'cz2__text-editor__field',
                        'hide--above-sm',
                        {
                            'cz2__text-editor__field--expanded': editMode === 'text',
                        }]
                    ">
                        <div class="cz2__text-editor__field-name">
                            <button class="cz2__image-button cz2__image-button--with-text cz2__image-button--monogram"
                                @click.prevent="changeText"
                            >
                                <span>{{$t('MONOGRAM_EDIT_CHANGE')}}</span>
                            </button>
                        </div>
                        <div class="cz2__text-editor__field-value cz2__text-editor__field-value--wide">
                            <div class="cz2__text-editor__input">
                                <input v-model.trim="selectedText" @input="updateText">

                                <button class="cz2__text-editor__input-clear" @click.prevent="clearText" :aria-label="$t('ACTION_CLEAR')"></button>
                            </div>
                        </div>
                    </div>

                    <div v-if="editMode == null" class="cz2__text-editor__field hide--below-sm">
                        <div class="cz2__text-editor__field-name cz2__type__small">
                            <span>{{$t('MONOGRAM_EDIT_INITIALS')}}</span>
                        </div>
                        <div class="cz2__text-editor__field-value">
                            <div class="cz2__text-editor__input">
                                <input v-model.trim="selectedText" @input="updateText" :placeholder="$t('MONOGRAM_EDIT_INITIALS_PLACEHOLDER')">

                                <button class="cz2__text-editor__input-clear" @click.prevent="clearText" :aria-label="$t('ACTION_CLEAR')"></button>
                            </div>
                        </div>
                    </div>

                    <div v-if="personalizationMethod !== 'etching' && (editMode == null || editMode === 'color')"
                        :class="[
                            'cz2__text-editor__field',
                            {
                                'cz2__text-editor__field--expanded': editMode === 'color',
                            }
                        ]"
                    >
                        <div class="cz2__text-editor__field-name cz2__type__small">
                            <button class="cz2__image-button cz2__image-button--with-text cz2__image-button--color cz2__text-editor__color-button"
                                @click.prevent="editSmallColor"
                            >
                                <span class="cz2__text-editor__color-button__swatch" :style="selectedColorStyle"></span>

                                <span>{{$t('TEXT_EDIT_COLOR')}}</span>
                            </button>

                            <span>{{$t('TEXT_EDIT_COLOR')}}</span>
                        </div>
                        <div class="cz2__text-editor__field-value">
                            <div class="cz2__colors__options">
                                <button v-for="color in primaryColors" :key="color.code"
                                    :class="[
                                        'cz2__color-option',
                                        {
                                            'cz2__color-option--selected': selectedColor && selectedColor.code === color.code,
                                            'cz2__color-option--border': color.custom['v-border'] === 'true',
                                        }
                                    ]"
                                    @click.prevent="pickColor(color)"
                                    :aria-label="color.name"
                                >
                                    <span class="cz2__color-option__color" :style="getColorStyle(color)">
                                    </span>
                                </button>

                                <button class="cz2__color-more" @click.prevent="editColor">
                                    <span class="cz2__color-more__icon">
                                    </span>

                                    <span class="cz2__color-more__text">{{$t('COLOR_MORE')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>

                    <div v-if="editMode == null || editMode === 'alignment'"
                        :class="[
                            'cz2__text-editor__field',
                            {
                                'cz2__text-editor__field--expanded': editMode === 'alignment',
                            }
                        ]"
                    >
                        <div class="cz2__text-editor__field-name cz2__type__small">
                            <button class="cz2__image-button cz2__image-button--with-text cz2__image-button--align-center"
                                @click.prevent="editAlignment"
                            >
                                <span>{{$t('IMAGE_EDIT_ALIGNMENT')}}</span>
                            </button>

                            <span>{{$t('IMAGE_EDIT_ALIGNMENT')}}</span>
                        </div>
                        <div class="cz2__text-editor__field-value">
                            <button class="cz2__image-button cz2__image-button--align-left"
                                :aria-label="$t('IMAGE_EDIT_ALIGN_LEFT')"
                                @click.prevent="alignLeft">
                            </button>

                            <button class="cz2__image-button cz2__image-button--align-center cz2__ml-10"
                                :aria-label="$t('IMAGE_EDIT_ALIGN_CENTER')"
                                @click.prevent="alignCenter">
                            </button>

                            <button class="cz2__image-button cz2__image-button--align-right cz2__ml-10"
                                :aria-label="$t('IMAGE_EDIT_ALIGN_RIGHT')"
                                @click.prevent="alignRight">
                            </button>

                            <button class="cz2__image-button cz2__image-button--align-top cz2__ml-10"
                                :aria-label="$t('IMAGE_EDIT_ALIGN_TOP')"
                                @click.prevent="alignTop">
                            </button>

                            <button class="cz2__image-button cz2__image-button--align-v-center cz2__ml-10"
                                :aria-label="$t('IMAGE_EDIT_ALIGN_VCENTER')"
                                @click.prevent="alignVCenter">
                            </button>

                            <button class="cz2__image-button cz2__image-button--align-bottom cz2__ml-10"
                                :aria-label="$t('IMAGE_EDIT_ALIGN_BOTTOM')"
                                @click.prevent="alignBottom">
                            </button>
                        </div>
                    </div>

                    <div v-if="editMode == null || editMode === 'layering'"
                        :class="[
                            'cz2__text-editor__field',
                            {
                                'cz2__text-editor__field--expanded': editMode === 'layering',
                            }
                        ]"
                    >
                        <div class="cz2__text-editor__field-name cz2__type__small">
                            <button class="cz2__image-button cz2__image-button--with-text cz2__image-button--layer-any"
                                @click.prevent="editLayering"
                            >
                                <span>{{$t('IMAGE_EDIT_LAYERING')}}</span>
                            </button>

                            <span>{{$t('IMAGE_EDIT_LAYERING')}}</span>
                        </div>
                        <div class="cz2__text-editor__field-value">
                            <button class="cz2__image-button cz2__image-button--layer-down"
                                :aria-label="$t('IMAGE_EDIT_LAYER_DOWN')"
                                @click.prevent="layerDown">
                            </button>

                            <button class="cz2__image-button cz2__image-button--layer-up cz2__ml-10"
                                :aria-label="$t('IMAGE_EDIT_LAYER_UP')"
                                @click.prevent="layerUp">
                            </button>
                        </div>
                    </div>

                    <div v-if="editMode == null" class="cz2__text-editor__field">
                        <div class="cz2__text-editor__field-name cz2__type__small">
                            <button class="cz2__image-button cz2__image-button--with-text cz2__image-button--remove" @click.prevent="removeText">
                                <span>{{$t('TEXT_EDIT_REMOVE')}}</span>
                            </button>

                            <span>{{$t('TEXT_EDIT_REMOVE')}}</span>
                        </div>
                        <div class="cz2__text-editor__field-value">
                            <button class="cz2__image-button cz2__image-button--remove" :aria-label="$t('TEXT_EDIT_REMOVE')" @click.prevent="removeText">
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="mode === 'color'"
                :class="[
                    'cz2__panel__body',
                    {
                        'cz2__panel__body--hack': panelBodyHack
                    }
                ]">
                <panel-header :title="$t('TEXT_EDIT_COLOR_CHANGE') + (selectedColorText ? (' &mdash; ' + selectedColorText) : '')" />

                <div class="cz2__colors__options cz2__colors__options--fullscreen">
                    <button v-for="color in availableColors" :key="color.code"
                        :class="[
                            'cz2__color-option',
                            {
                                'cz2__color-option--selected': selectedColor && selectedColor.code === color.code,
                                'cz2__color-option--border': color.custom['v-border'] === 'true',
                            }
                        ]"
                        @click.prevent="pickColor(color)"
                        :aria-label="color.name"
                    >
                        <span class="cz2__color-option__color" :style="getColorStyle(color)">
                        </span>
                    </button>
                </div>
            </div>

            <!-- List View -->
            <div v-if="mode === 'list'" class="cz2__panel__actions">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="saveEdit"><span>{{$t('MENU_BACK')}}</span></button>
            </div>

            <!-- Edit View -->
            <div v-if="mode === 'edit'" class="cz2__panel__actions">
                <template v-if="editMode != null">
                    <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="backToEdit"><span>{{$t('ACTION_CONFIRM')}}</span></button>
                </template>
                <template v-else>
                    <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancelEdit"><span>{{$t('ACTION_CANCEL')}}</span></button>
                    <button class="cz2__panel-action cz2__panel-action--accept" @click.prevent="saveEdit"><span>{{$t('ACTION_SAVE')}}</span></button>
                </template>
            </div>

            <!-- Color View -->
            <div v-if="mode === 'color'" class="cz2__panel__actions">
                <button class="cz2__panel-action cz2__panel-action--cancel" @click.prevent="cancelColor"><span>{{$t('ACTION_CANCEL')}}</span></button>
                <button class="cz2__panel-action cz2__panel-action--accept" @click.prevent="acceptColor"><span>{{$t('ACTION_SAVE')}}</span></button>
            </div>
        </focus-lock>
    </fieldset>
</template>

<style lang="scss">
    @import "../style/variables.scss";

    #cz2.cz2 {
        .cz2__monogram.cz2__monogram--color {
            height: 100%;
        }

        .cz2__text-list-action__monogram-icon {
            display: block;
            flex: 0 0 auto;

            width: $button-height;
            height: $button-height;

            margin-right: 12px;

            background: transparent url(../assets/menu-monogram@2x.png) no-repeat center/contain;
        }

        .cz2__monogram__options {
            margin-left: -5px;
            margin-right: -5px;

            @include respond-above(sm) {
                margin-top: 20px;
                margin-bottom: -10px;
            }
        }

        .cz2__monogram-option {
            position: relative;

            margin-left: 5px;
            margin-right: 5px;
            margin-bottom: 10px;

            width: 44px;
            height: 44px;
            border-radius: 44px;
            border: 1px solid #f0f0f0;
            background-color: #ffffff;

            overflow: hidden;

            @include respond-above(sm) {
                width: 60px;
                height: 60px;
                border-radius: 60px;
            }

            &.cz2__monogram-option--selected {
                &:after {
                    content: '';

                    position: absolute;
                    display: block;

                    left: 0;
                    top: 0;

                    width: 100%;
                    height: 100%;

                    border: 2px solid #000;
                    border-radius: 60px;
                }
            }
        }

        .cz2__monogram-option__image {
            position: absolute;

            left: 4px;
            top: 4px;
            right: 4px;
            bottom: 4px;

            background-size: contain;
        }

        .cz2__text-editor__field-value {
            .cz2__monogram-option {
                margin: 0;

                margin-left: 5px;
                margin-right: 5px;

                @include respond-above(sm) {
                    margin-left: 0px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
        }
    }
</style>

<script>
    import FocusLock from 'vue-focus-lock';
    import DetailsHeader from './DetailsHeader.vue';
    import PanelHeader from './PanelHeader.vue';
    import PanelBodyHack from './PanelBodyHack';

    import * as constants from '../constants';

    import designArea from '../utilities/designArea';

    export default {
        mixins: [PanelBodyHack],
        components: {
            FocusLock,
            DetailsHeader,
            PanelHeader,
        },
        data() {
            return {
                focusLockDisabled: true,
                monogramLockDisabled: true,

                mode: 'list',
                editMode: null,

                editPlacement: null,
                editComponent: null,

                selectedText: '',
                selectedFont: '',

                lastSelectedNonprimary: null,
            };
        },
        computed: {
            /**
             * Current view controller.
             */
            viewController() {
                return this.$store.state.customizer.viewController;
            },

            /**
             * Currently selected view.
             */
            currentView() {
                return this.$store.state.customizer.currentView;
            },

            /**
             * Gets a list of filled images.
             */
            filledMonogramPlacements() {
                return this.$store.getters.filledMonogramPlacements;
            },

            /**
             * Gets a list of free images.
             */
            emptyMonogramPlacements() {
                return this.$store.getters.emptyMonogramPlacements;
            },

            /**
             * Current customization mode.
             */
            personalizationMethod() {
                return this.$store.state.customizer.personalizationMethod;
            },

            /**
             * Figure out a list of available styles.
             */
            availableStyles() {
                let placement = this.editPlacement;

                if (placement == null) {
                    if (this.emptyMonogramPlacements.length > 0) {
                        placement = this.emptyMonogramPlacements[0].placement;
                    }
                }

                if (placement) {
                    const fonts = [];

                    placement.components.forEach((c) => {
                        const font = c.description.find((d) => d.definition === constants.DEFINITION_MONOGRAM);

                        if (font) {
                            if (!fonts.some((f) => f.code === font.code)) {
                                const copy = { ...font };

                                if (copy.custom == null) {
                                    copy.custom = {};
                                }

                                copy.custom = { ...copy.custom, ...c.custom };

                                fonts.push(copy);
                            }
                        }
                    });

                    return fonts;
                }

                return [];
            },

            /**
             * Figure out a list of available colors.
             */
            availableColors() {
                return this.$store.getters.availablePersonalizationColors;
            },

            /**
             * Get a list of primary colors to be shown in the plain list.
             */
            primaryColors() {
                const primaries = [];

                if (this.lastSelectedNonprimary) {
                    primaries.push(this.lastSelectedNonprimary);
                }

                primaries.push(...this.availableColors.filter((c) => {
                    if (c.custom && c.custom['v-primary-color'] === 'true') {
                        return true;
                    }

                    return false;
                }));

                return primaries;
            },

            /**
             * Figure out the selected color caption.
             */
            selectedColorText() {
                const color = this.selectedColor;

                return color ? color.name : '';
            },

            /**
             * Get selected color.
             */
            selectedColor() {
                if (this.editPlacement) {
                    const selectedActual = this.viewController.selectedAtPlacement(this.editPlacement.code);

                    const selected = this.availableColors.find((x) => x.custom.hex === selectedActual.custom['personalization-color']);

                    return selected;
                }

                return null;
            },

            /**
             * Figure out the selected color CSS style.
             */
            selectedColorStyle() {
                const css = {};

                if (this.editPlacement) {
                    const selected = this.viewController.selectedAtPlacement(this.editPlacement.code);

                    const hex = selected.custom['personalization-color'];

                    css.backgroundColor = hex.startsWith('#') ? hex : `#${hex}`;
                }

                return css;
            },

            /**
             * Get selected style.
             */
            selectedStyle() {
                if (this.editPlacement) {
                    const selected = this.viewController.selectedAtPlacement(this.editPlacement.code);

                    return selected;
                }

                return null;
            },

            /**
             * Get selected style "short" description.
             */
            selectedStyleDescription() {
                if (this.editPlacement) {
                    const selected = this.viewController.selectedAtPlacement(this.editPlacement.code);

                    const description = selected.description.find((d) => d.definition === constants.DEFINITION_MONOGRAM);

                    return description;
                }

                return null;
            },
        },
        watch: {
            selectedFont() {
                this.updateFont();
            },

            /**
             * Load font files so we could show the fonts preview.
             */
            availableFonts() {
                this.$store.dispatch('loadFonts', this.availableFonts);
            },

            /**
             * Saves the last selected non primary color so it could be shown in the quick picker.
             */
            selectedColor() {
                if (this.editPlacement) {
                    if (this.selectedColor && this.selectedColor.custom['v-primary-color'] !== 'true') {
                        this.lastSelectedNonprimary = this.selectedColor;
                    }
                }
            },

            /**
             * Move the design if current view changes.
             */
            currentView() {
                this.moveDesign();
            },
        },
        mounted() {
            // Otherwise this messes with transition animation because browsers will try to scroll to the focused item, which would be off-screen.
            this.$store.state.eventBus.$once('secondaryEntered', () => {
                // this.focusLockDisabled = false;
                this.monogramLockDisabled = false;
            });

            // When the component is loaded, capture the current state of the view controller and save it in case
            // we need to revert to the previous state and toss away all customizations.
            //
            // At any given time there should be only one module that can do the revert.
            this.captureController();

            if (this.filledMonogramPlacements.length === 0) {
                if (this.emptyMonogramPlacements.length > 0) {
                    this.listAddMonogram();
                }
            }

            if (this.selectedColor && this.selectedColor.custom && this.selectedColor.custom['v-primary-color'] !== 'true') {
                this.lastSelectedNonprimary = this.selectedColor;
            }
        },
        beforeDestroy() {
            // Reenable swiping.
            this.$store.dispatch('lockSwipe', false);
            this.$store.dispatch('editPlacement', null);
        },
        methods: {
            /**
             * Captures the current state and active controller so we could cancel changes if necessary.
             */
            captureController() {
                if (this.viewController) {
                    this.revertController = this.viewController.clone({ excludeEvents: false });
                }
            },

            /**
             * Accept color choice.
             */
            accept() {
                // Keep the current configured view controller, and go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Reject color changes and restore the original selection.
             */
            cancel() {
                // Revert back to the state of the controller as was captured when the component was mounted.
                this.$store.dispatch('showController', this.revertController);

                // Go back to the main screen.
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Enters image editing mode.
             */
            beginEdit(placement, component) {
                this.undoEditController = this.viewController.clone({ excludeEvents: false });

                this.editPlacement = placement;
                this.editComponent = component;
                this.mode = 'edit';

                this.$store.dispatch('lockSwipe', true);
                this.$store.dispatch('editPlacement', placement);

                this.selectedText = component.custom['personalization-text'] || '';

                const font = component.description.find((d) => d.definition === constants.DEFINITION_FONT);
                if (font) {
                    this.selectedFont = { ...font, ...{ custom: { ...font.custom, ...component.custom } } };
                }

                if (component.custom['v-design-on']) {
                    this.$store.dispatch('switchToDesignView', component.custom['v-design-on']);
                }
            },

            /**
             * Cancels image editing.
             */
            cancelEdit() {
                // This was the only placement being created, do a full rollback.
                if (this.filledMonogramPlacements.length === 1) {
                    this.cancel();
                    return;
                }

                if (this.undoEditController) {
                    this.$store.dispatch('showController', this.undoEditController);
                    this.undoEditController = null;
                }

                this.mode = 'list';

                this.$store.dispatch('lockSwipe', false);
                this.$store.dispatch('editPlacement', null);
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Saves image edits.
             */
            saveEdit() {
                this.mode = 'list';

                this.$store.dispatch('lockSwipe', false);
                this.$store.dispatch('editPlacement', null);
                this.$store.dispatch('selectStep', null);
            },

            /**
             * Update font selection.
             */
            updateFont() {
                this.viewController.updateSimilarComponent(this.editPlacement.code, constants.DEFINITION_FONT, this.selectedFont.code);
            },

            /**
             * Update personalization.
             */
            updateText() {
                this.viewController.updatePersonalization(this.editPlacement.code, this.selectedText).then((result) => {
                    if (result.accepted) {
                        if (result.as) {
                            this.selectedText = result.as;
                        }
                    } else if (result.lastValid != null) {
                        this.selectedText = result.lastValid;
                    }
                });
            },

            /**
             * Clear text personalization.
             */
            clearText() {
                this.selectedText = '';

                this.viewController.updatePersonalization(this.editPlacement.code, '').then((result) => {
                    if (result.accepted) {
                        if (result.as) {
                            this.selectedText = result.as;
                        }
                    } else if (result.lastValid != null) {
                        this.selectedText = result.lastValid;
                    }
                });
            },

            /**
             * Change text.
             */
            changeText() {
                this.editMode = 'text';
            },

            /**
             * Align the image to the left.
             */
            alignLeft() {
                if (this.currentView) {
                    const { left } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                    if (left != null) {
                        this.viewController.commitCustomAttributes(this.editPlacement.code, {
                            'personalization-x': left,
                            'personalization-alignment': 'left',
                        }, {
                            propagate: true,
                        });
                    }
                }
            },

            /**
             * Align the image to the center.
             */
            alignCenter() {
                if (this.currentView) {
                    const { left, right } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                    if (left != null && right != null) {
                        const width = +this.editComponent.custom['personalization-width'];

                        this.viewController.commitCustomAttributes(this.editPlacement.code, {
                            'personalization-x': ((left + right) * 0.5) - (width * 0.5),
                            'personalization-alignment': 'center',
                        }, {
                            propagate: true,
                        });
                    }
                }
            },

            /**
             * Align the image to the right.
             */
            alignRight() {
                if (this.currentView) {
                    const { right } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                    if (right) {
                        const width = +this.editComponent.custom['personalization-width'];

                        this.viewController.commitCustomAttributes(this.editPlacement.code, {
                            'personalization-x': right - width,
                            'personalization-alignment': 'right',
                        }, {
                            propagate: true,
                        });
                    }
                }
            },

            /**
             * Align the image to the top.
             */
            alignTop() {
                if (this.currentView) {
                    const { top } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                    if (top != null) {
                        this.viewController.commitCustomAttributes(this.editPlacement.code, {
                            'personalization-y': top,
                            'personalization-vertical-alignment': 'top',
                        }, {
                            propagate: true,
                        });
                    }
                }
            },

            /**
             * Align the image to the center.
             */
            alignVCenter() {
                if (this.currentView) {
                    const { top, bottom } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                    if (top != null && bottom != null) {
                        const height = +this.editComponent.custom['personalization-height'];

                        this.viewController.commitCustomAttributes(this.editPlacement.code, {
                            'personalization-y': ((top + bottom) * 0.5) - (height * 0.5),
                            'personalization-vertical-alignment': 'center',
                        }, {
                            propagate: true,
                        });
                    }
                }
            },

            /**
             * Align the image to the bottom.
             */
            alignBottom() {
                if (this.currentView) {
                    const { bottom } = designArea(this.$store.state.customizer, this.editComponent.custom['v-design-on']);

                    if (bottom != null) {
                        const height = +this.editComponent.custom['personalization-height'];

                        this.viewController.commitCustomAttributes(this.editPlacement.code, {
                            'personalization-y': bottom - height,
                            'personalization-vertical-alignment': 'bottom',
                        }, {
                            propagate: true,
                        });
                    }
                }
            },

            /**
             * Move the current image up a layer.
             */
            layerUp() {
                this.$store.dispatch('layerUp', this.editPlacement);
            },

            /**
             * Move the current image down a layer.
             */
            layerDown() {
                this.$store.dispatch('layerDown', this.editPlacement);
            },

            /**
             * Get monogram button style.
             */
            getMonogramStyle(option) {
                const css = {};

                if (option.custom && option.custom['icon-image']) {
                    const image = option.custom['icon-image'];

                    css.backgroundImage = `url(${image})`;
                }

                return css;
            },

            /**
             * Begins adding a new text.
             */
            listAddMonogram() {
                if (this.emptyMonogramPlacements.length > 0 && this.availableStyles.length > 0) {
                    this.$store.dispatch('validateEditableViews');
                    this.$store.dispatch('switchToCommonView');

                    const { placement } = this.emptyMonogramPlacements[0];

                    this.$store.dispatch('takeEmptyPlacement', placement);

                    const startWithStyle = this.availableStyles[0];

                    this.viewController.updateSimilarComponent(placement.code, constants.DEFINITION_MONOGRAM, startWithStyle.code);

                    const component = this.viewController.selectedAtPlacement(placement.code);

                    // ... and center manually in the current view.
                    if (this.currentView) {
                        const { view } = this.currentView;

                        this.$store.dispatch('renderOnlyOnView', {
                            view: this.currentView,
                        });

                        if (view.custom) {
                            const {
                                left, right, top, bottom,
                            } = designArea(this.$store.state.customizer, view.custom['v-design-area']);

                            const width = +component.custom['personalization-width'];
                            const height = +component.custom['personalization-height'];

                            if (left != null && right != null && top != null && bottom != null) {
                                this.viewController.commitCustomAttributes(placement.code, {
                                    'v-design-on': view.custom['v-design-area'],
                                    mask: view.custom['v-design-mask'],
                                    'personalization-x': ((left + right) * 0.5) - (width * 0.5),
                                    'personalization-y': ((top + bottom) * 0.5) - (height * 0.5),
                                    'personalization-rotate': 0,
                                    'personalization-scale': 1,
                                }, {
                                    propagate: true,
                                });
                            }
                        }
                    }

                    this.beginEdit(placement, component);
                }
            },

            /**
             * Removes a text.
             */
            listRemoveMonogram(text) {
                this.$store.dispatch('clearPlacement', text);
            },

            /**
             * Edits an text.
             */
            listEditMonogram(text) {
                this.beginEdit(text.placement, text.component);
            },

            /**
             * Edit text color on small screens.
             */
            editSmallColor() {
                this.revertColor = this.selectedColor;

                this.editMode = 'color';
            },

            /**
             * Edit text color.
             */
            editColor() {
                this.revertColor = this.selectedColor;

                this.mode = 'color';
            },

            /**
             * Edit text font.
             */
            editFont() {
                this.editMode = 'font';
            },

            /**
             * Edit text layering.
             */
            editLayering() {
                this.editMode = 'layering';
            },

            /**
             * Edit text alignment.
             */
            editAlignment() {
                this.editMode = 'alignment';
            },

            /**
             * Back to editing menu.
             */
            backToEdit() {
                this.editMode = null;
            },

            /**
             * Build font style object for the font selector.
             */
            getFontStyle(option) {
                const css = {};

                if (option.custom && option.custom['v-webfont-family']) {
                    css.fontFamily = option.custom['v-webfont-family'];
                }

                return css;
            },

            /**
             * Begin selecting a color.
             */
            selectColor() {
                this.revertColor = this.selectedColor;

                this.mode = 'color';
            },

            /**
             * Get color style.
             */
            getColorStyle(option) {
                const css = {};

                if (option.custom && option.custom.hex) {
                    const { hex } = option.custom;

                    css.backgroundColor = hex.startsWith('#') ? hex : `#${hex}`;
                }

                return css;
            },

            /**
             * Update the color selection.
             */
            pickColor(color) {
                this.viewController.commitCustomAttributes(this.editPlacement.code, {
                    'personalization-color': color.custom.hex,
                }, {
                    propagate: true,
                });
            },

            /**
             * Accepts color selection.
             */
            acceptColor() {
                this.mode = 'edit';
            },

            /**
             * Revert color selection.
             */
            cancelColor() {
                if (this.revertColor) {
                    this.viewController.commitCustomAttributes(this.editPlacement.code, {
                        'personalization-color': this.revertColor.custom.hex,
                    }, {
                        propagate: true,
                    });
                }

                this.mode = 'edit';
            },

            /**
             * Removes current text block.
             */
            removeText() {
                this.$store.dispatch('clearPlacement', {
                    placement: this.editPlacement,
                });

                this.mode = 'list';

                this.$store.dispatch('lockSwipe', false);
                this.$store.dispatch('editPlacement', null);
            },

            /**
             * Update the style selection.
             */
            pickStyle(option) {
                this.viewController.updateSimilarComponent(this.editPlacement.code, constants.DEFINITION_MONOGRAM, option.code);
            },

            /**
             * Change monogramming style.
             */
            changeStyle() {
                this.editMode = 'changeStyle';
            },

            /**
             * Accepts style change.
             */
            acceptChangeStyle() {
                this.mode = 'edit';
            },

            /**
             * Cancels style change.
             */
            cancelChangeStyle() {
                if (this.revertMonogramStyle) {
                    this.viewController.updateSimilarComponent(this.editPlacement.code, constants.DEFINITION_MONOGRAM, this.revertMonogramStyle.code);
                }

                this.mode = 'edit';
            },

            /**
             * Moves the current design to another surface.
             */
            moveDesign() {
                if (this.editPlacement && this.editComponent && this.currentView) {
                    const viewDesignArea = this.currentView.view.custom['v-design-area'];
                    const designOn = this.editComponent.custom['v-design-on'];

                    if (viewDesignArea !== designOn) {
                        this.$store.dispatch('renderOnlyOnView', {
                            view: this.currentView,
                        });

                        if (this.viewController.blueprint.custom['v-etch-either-side'] === 'true') {
                            this.$store.dispatch('moveEverythingOver', {
                                view: this.currentView,
                                moved: this.editComponent,
                            });
                        } else {
                            const {
                                left, right, top, bottom,
                            } = designArea(this.$store.state.customizer, viewDesignArea);

                            const width = +this.editComponent.custom['personalization-width'];
                            const height = +this.editComponent.custom['personalization-height'];

                            if (left != null && right != null && top != null && bottom != null) {
                                this.viewController.commitCustomAttributes(this.editPlacement.code, {
                                    'v-design-on': viewDesignArea,
                                    mask: this.currentView.view.custom['v-design-mask'],
                                    'personalization-x': ((left + right) * 0.5) - (width * 0.5),
                                    'personalization-y': ((top + bottom) * 0.5) - (height * 0.5),
                                }, {
                                    propagate: true,
                                });
                            }
                        }
                    }
                }
            },
        },
    };
</script>
